import { memo } from "react";
import FuseNavVerticalLayout1 from "./vertical/FuseNavVerticalLayout1";
import type { FuseNavItemType } from "./types/FuseNavItemType";

export interface FuseNavigationProps {
	className?: string;
	dense?: boolean;
	active?: boolean;
	onItemClick?: (T: FuseNavItemType) => void;
	aoAnteciparItem?: (item: FuseNavItemType) => void;
	navigation?: FuseNavItemType[];
	layout?: "horizontal" | "vertical" | "vertical-2";
	firstLevel?: boolean;
	selectedId?: string;
	checkPermission?: boolean;
}

/**
 * FuseNavigation
 * Componente para exibir uma barra de navegação que contém componentes FuseNavItem
 * e atua como pai, fornecendo props para seus componentes filhos.
 */
function FuseNavigation(props: Readonly<FuseNavigationProps>) {
	const { navigation, layout = "vertical" } = props;

	if (!navigation || navigation.length === 0) return null;

	return layout === "vertical" ? <FuseNavVerticalLayout1 checkPermission={false} {...props} /> : null;
}

export default memo(FuseNavigation);
